import { FullWidthPrimaryButton } from 'commonStyledComponents'
import styled from 'styled-components'

export const MaintenancePageWrapper = styled.div`
  display: flex;
  position: fixed;
  inset: 0 0 0 0;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: calc(var(--layer-fullpage-modal) + 1);
  color: #fff;
  text-align: center;
`

export const MaintenancePageModal = styled.div`
  background: #fff;
  padding: 0.82051rem 0.41026rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 0.25641rem;
`

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PageTitle = styled.div`
  font-size: 0.41026rem;
  font-weight: 700;
  padding-bottom: 0.21rem;
  color: #2e2e2e;
`

export const PageContentLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.41rem;
`
export const PageContentLine = styled.div`
  font-size: 0.35rem;
  line-height: 150%;
  color: #787878;
`

export const PageFooter = styled.div`
  position: absolute;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  right: 0;
  font-size: 0.4rem;
`

export const SecondButton = styled(FullWidthPrimaryButton)`
  background: var(--button-secondary-background);
  color: var(--button-secondary-color);
  margin-top: 0.2rem;
`
export const ThirdButton = styled(FullWidthPrimaryButton)`
  background: transparent;
  color: #2e2e2e;
  margin-top: 0.2rem;
`
